module.exports = __webpack_public_path__ + "files/66fc1fe708ad22acee944d7fc5b1fbbe.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people_body-3.png
// module id = 500
// module chunks = 76